import { Injectable } from '@angular/core';
import { UrlService } from 'src/app/shared/services/url/url.service';
import { environment } from 'src/environments/environment';
import { CategoriesUri, PhysicalOrderUri, CustomerUri, ReportstUri, OrderUri, SubscriptionUri, AccessoriesUri } from 'src/app/core/config/config.model';
import { AppConfigService } from 'src/app/core/config/config.service';

@Injectable({
    providedIn: 'root'
})
export class GiftCardsUriService {
    private baseUrl: String;
    private baseUrlTwo: String;
    private categoriesUri: CategoriesUri;
    private subscriptionUri: SubscriptionUri
    private physicalOrderUri: PhysicalOrderUri;
    private customerUri: CustomerUri;
    private reportsUri: ReportstUri;
    private orderUri: OrderUri;
    private accessoriesUri: AccessoriesUri;


    constructor(private urlService: UrlService, private apiConfig: AppConfigService) {

        this.baseUrl = environment.baseUrl;
        this.baseUrlTwo = environment.baseUrlTwo;
        this.categoriesUri = apiConfig.appConfig.categoriesUri;
        this.physicalOrderUri = apiConfig.appConfig.physicalOrderUri;
        this.reportsUri = apiConfig.appConfig.reportsUri;
        this.orderUri = apiConfig.appConfig.orderUri;
        this.subscriptionUri = apiConfig.appConfig.subscriptionUri;
        this.accessoriesUri = apiConfig.appConfig.accessoriesUri;

    }

    getCategoriesUri() {
        return this.urlService.combineUri(this.baseUrlTwo, this.categoriesUri.cards, this.categoriesUri.categories);
    }

    getProductListUri() {
        return this.urlService.combineUri(this.baseUrl, this.categoriesUri.cards, this.categoriesUri.products)
    }

    getAccessoriesProductsUri() {
        return this.urlService.combineUri(this.baseUrl, this.accessoriesUri.accessories, this.accessoriesUri.accessoryProducts);
    }

    getAccessoryOrdersUri() {
        return this.urlService.combineUri(this.baseUrl, this.accessoriesUri.accessories, this.accessoriesUri.accessoryOrders)
    }

    getAccessoryOrderDetail(id:number){
        return this.urlService.combineUri(this.baseUrl, this.accessoriesUri.accessories,this.accessoriesUri.accessoryOrders,id)
    }

    getPhysicalOrdersListUri() {
        return this.urlService.combineUri(this.baseUrl, this.categoriesUri.cards, this.physicalOrderUri.transactions);
    }
    
    getPhysicalOrdersListArchiveUri() {
        return this.urlService.combineUri(this.baseUrl, this.categoriesUri.cards, this.physicalOrderUri.transactions);
    }

    getUserDetailUri(userId: number) {
        return this.urlService.combineUri(this.baseUrl, this.customerUri.customers, this.customerUri.my_customers, userId)
    }

    getReportUri() {
        return this.urlService.combineUri(this.baseUrl, this.reportsUri.reports, this.reportsUri.panel, this.reportsUri.physical_product_finance);
    }

    getProductDetailUri(productId: number) {
        return this.urlService.combineUri(this.baseUrl, this.categoriesUri.cards, this.categoriesUri.products, productId);
    }

    getUserReportUri() {
        return this.urlService.combineUri(this.baseUrl, this.reportsUri.reports, this.reportsUri.panel, this.reportsUri.physical_user_finance);
    }

    getOrdersUri() {
        return this.urlService.combineUri(this.baseUrl, this.categoriesUri.cards, this.orderUri.transactions)
    }

    getGiftCardStatusUri() {
        return this.urlService.combineUri(this.baseUrlTwo, this.categoriesUri.cards, this.categoriesUri.check);
    }

    getActivateGiftCardUri() {
        return this.urlService.combineUri(this.baseUrlTwo, this.categoriesUri.cards, this.categoriesUri.transactions, this.categoriesUri.activate)
    }

    getBulkActivateGiftCardUri() {
        return this.urlService.combineUri(this.baseUrlTwo, this.categoriesUri.cards, this.categoriesUri.transactions, this.categoriesUri.multi_activate)
    }

    getSubscriptionCardsUri() {
        return this.urlService.combineUri(this.baseUrl, this.subscriptionUri.subscriptions, this.subscriptionUri.payment_cards)
    }

    getSubscriptionCustomerCardsUri() {
        return this.urlService.combineUri(this.baseUrl, this.subscriptionUri.subscriptions, this.subscriptionUri.customer_cards)
    }

    getSubscriptionGatewayCustomerCardUri(gatewayId: number) {
        return this.urlService.combineUri(this.baseUrl, this.subscriptionUri.subscriptions, this.subscriptionUri.customer_cards, gatewayId)
    }

    getSubscriptionOrderUri() {
        return this.urlService.combineUri(this.baseUrl, this.subscriptionUri.subscriptions, this.subscriptionUri.order)
    }

    getSubscriptionOrderDetailUri(id: number) {
        return this.urlService.combineUri(this.baseUrl, this.subscriptionUri.subscriptions, this.subscriptionUri.order, id)
    }

    getSubscriptionOrderCancelUri(id: number) {
        return this.urlService.combineUri(this.baseUrl, this.subscriptionUri.subscriptions, this.subscriptionUri.order, id, this.subscriptionUri.cancel_order)
    }

    getSubscriptionMethodUri() {
        return this.urlService.combineUri(this.baseUrl, this.subscriptionUri.subscriptions, this.subscriptionUri.gateway)
    }

    getSubscriptionOrderValidationUri() {
        return this.urlService.combineUri(this.baseUrl, this.subscriptionUri.subscriptions, this.subscriptionUri.order, this.subscriptionUri.validation)
    }

    getAccessoryOrderValidationUri() {
        return this.urlService.combineUri(this.baseUrl, this.accessoriesUri.accessories, this.accessoriesUri.accessoryOrders, this.accessoriesUri.validation)
    }

    getSubscriptionPaymentsUri() {
        return this.urlService.combineUri(this.baseUrl, this.subscriptionUri.subscriptions, this.subscriptionUri.payments)
    }

}